import { render, staticRenderFns } from "./ATM98.vue?vue&type=template&id=15d6da96&scoped=true"
import script from "./ATM98.vue?vue&type=script&lang=ts"
export * from "./ATM98.vue?vue&type=script&lang=ts"
import style0 from "./ATM98.vue?vue&type=style&index=0&id=15d6da96&prod&lang=scss&scoped=true"
import style1 from "./ATM98.vue?vue&type=style&index=1&id=15d6da96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d6da96",
  null
  
)

export default component.exports